import React from 'react';
import { Tooltip } from '@clearcover/atlas';
import { shouldShowBonusEntries } from 'Rewards/utils/bonusVisibility';
import styles from './styles.module.css';

interface BonusEntriesBadgeProps {
  phaseNumber: number;
  bonusCount: number;
}

export const BonusEntriesBadge = ({
  phaseNumber,
  bonusCount,
}: BonusEntriesBadgeProps) => {
  if (!shouldShowBonusEntries(phaseNumber)) return null;
  return (
    <div className={styles.bonusEntriesRow}>
      <span className={styles.bonusCount} data-testid="bonus-entries-count">
        +{bonusCount} BONUS
      </span>
      <Tooltip tooltip="These bonus entries will expire if not used in this act.">
        <span
          className={styles.infoIconWrapper}
          data-testid="bonus-entries-info-icon"
          aria-label="Bonus entries information"
        >
          ⓘ
        </span>
      </Tooltip>
    </div>
  );
};
